define('widgets/gamesList/viewmodel',['knockout', 'underscore', 'jquery'], function (ko, _, $) {

    var setupSelectionEvents =  _.once(function() {
        $(document.body).on('click', function(e) {
            $('.game-tile').removeClass('selected');
            $(e.target).closest('.game-tile').addClass('selected');
        });
    });

    var GamesList = function(getField) {
        var self = this;

        self.selectedGameId = ko.observable();

        self.gameInMaintenanceText = getField('game_in_maintenance_text');
    };

    GamesList.prototype.activate = function(settings) {
        this.games = ko.computed(function() {
            var numberOfGames = settings.numberOfGames || settings.games().length;

            return _.take(settings.games(), numberOfGames);
        });
    };

    GamesList.prototype.selectGame = function(gameId) {
        this.selectedGameId(gameId);
    };

    GamesList.prototype.isSelected = function(gameId) {
        return gameId === this.selectedGameId();
    };

    GamesList.prototype.attached = function(view) {
        var self = this;

        setupSelectionEvents();
    };

    return GamesList;
});

